/* Tyrexin - BMI calculator (vanilla). Operates on the BMI section markup via data-attrs.
   Informational health tool (WHO classes) - no weight-loss promises.
   Strings read from window.WJ_BMI_I18N (injected by page-bmi.liquid); falls back to German.

   Each metric (height/weight) is driven by TWO synced controls: a number input and a
   range slider, both tagged data-bmi-<metric>. Editing either keeps the other in lock-step. */
(function () {
  "use strict";

  var i18n = window.WJ_BMI_I18N || {
    cat_under:   "Untergewicht",
    cat_normal:  "Normalgewicht",
    cat_over:    "Übergewicht",
    cat_obese:   "Adipositas",
    msg_under:   "Ihr BMI liegt unter dem Normalbereich. Eine ausgewogene Ernährung steht im Vordergrund.",
    msg_normal:  "Ihr BMI liegt im Normalbereich. Tyrexin® kann Ihre Routine unterstützend begleiten.",
    msg_over:    "Ihr BMI liegt leicht über dem Normalbereich. Erste sichtbare Veränderung in 8-12 Wochen ist realistisch.",
    msg_obese:   "Ihr BMI liegt im Bereich Adipositas. Ein begleiteter Ansatz über mehrere Monate ist sinnvoll.",
    goal_normal: "Normalbereich: {low}-{high} kg · Sie liegen im Zielbereich.",
    goal_over:   "Normalbereich: {low}-{high} kg · {delta} kg bis zur oberen Grenze.",
    goal_under:  "Normalbereich: {low}-{high} kg · {delta} kg bis zur unteren Grenze.",
    normalbereich: "Normalbereich"
  };

  var root = document.querySelector("[data-bmi]");
  if (!root) return;

  // Bounds mirror the markup's min/max so JS and HTML never drift apart.
  var BOUNDS = { height: { min: 120, max: 220 }, weight: { min: 35, max: 200 } };

  // Each metric has >=1 control (number input + slider). Collect them all.
  var ctrls = {
    height: toArray(root.querySelectorAll("[data-bmi-height]")),
    weight: toArray(root.querySelectorAll("[data-bmi-weight]"))
  };
  var valSpan = {
    height: root.querySelector("[data-bmi-height-val]"),
    weight: root.querySelector("[data-bmi-weight-val]")
  };

  var out    = root.querySelector("[data-bmi-value]");
  var cat    = root.querySelector("[data-bmi-category]");
  var marker = root.querySelector("[data-bmi-marker]");
  var msg    = root.querySelector("[data-bmi-message]");
  var goal   = root.querySelector("[data-bmi-goal]");

  // Canonical state, seeded from the first control's value (falls back to a sane default).
  var state = {
    height: seed("height", 170),
    weight: seed("weight", 78)
  };

  function toArray(nl) { return Array.prototype.slice.call(nl); }
  function clamp(v, b) { return Math.max(b.min, Math.min(b.max, v)); }

  function seed(metric, dflt) {
    var first = ctrls[metric][0];
    var n = first ? parseFloat(first.value) : NaN;
    return isFinite(n) ? clamp(n, BOUNDS[metric]) : dflt;
  }

  // BMI track maps 15..40 to 0..100%.
  function pct(bmi) { return Math.max(1.5, Math.min(98.5, ((bmi - 15) / (40 - 15)) * 100)); }

  function classify(bmi) {
    if (bmi < 18.5) return { key: "under",  label: i18n.cat_under };
    if (bmi < 25)   return { key: "normal", label: i18n.cat_normal };
    if (bmi < 30)   return { key: "over",   label: i18n.cat_over };
    return               { key: "obese",  label: i18n.cat_obese };
  }

  function message(c) {
    switch (c.key) {
      case "under":  return i18n.msg_under;
      case "normal": return i18n.msg_normal;
      case "over":   return i18n.msg_over;
      default:       return i18n.msg_obese;
    }
  }

  function fmtKg(n) { return (Math.round(n * 10) / 10).toFixed(1).replace(".", ","); }

  function goalText(c, low, high, wv) {
    if (c.key === "normal") {
      return i18n.goal_normal.replace("{low}", fmtKg(low)).replace("{high}", fmtKg(high));
    }
    if (wv >= high) {
      return i18n.goal_over
        .replace("{low}", fmtKg(low)).replace("{high}", fmtKg(high))
        .replace("{delta}", fmtKg(wv - high));
    }
    return i18n.goal_under
      .replace("{low}", fmtKg(low)).replace("{high}", fmtKg(high))
      .replace("{delta}", fmtKg(low - wv));
  }

  // Push canonical state out to every control + the slider fill + the value readout.
  // overwriteNumber=false leaves number fields untouched so live typing isn't fought.
  function render(metric, overwriteNumber) {
    var b = BOUNDS[metric], v = state[metric];
    var fill = ((v - b.min) / (b.max - b.min)) * 100;
    ctrls[metric].forEach(function (el) {
      if (el.type === "range") {
        if (String(el.value) !== String(v)) el.value = v;
        el.style.setProperty("--fill", fill + "%");
      } else if (overwriteNumber && el.value !== String(v)) {
        el.value = v;
      }
    });
    if (valSpan[metric]) valSpan[metric].textContent = v;
  }

  function update() {
    var hv = state.height, wv = state.weight;
    var m = hv / 100;
    var bmi = wv / (m * m);
    var bmiR = Math.round(bmi * 10) / 10;
    var c = classify(bmi);

    if (out)    out.textContent = bmiR.toFixed(1).replace(".", ",");
    if (cat)  { cat.textContent = c.label; cat.setAttribute("data-cat", c.key); }
    if (marker) marker.style.left = pct(bmi) + "%";
    if (msg)    msg.textContent = message(c);
    if (goal) {
      var low = 18.5 * m * m, high = 24.9 * m * m;
      goal.textContent = goalText(c, low, high, wv);
    }
    root.setAttribute("data-bmi-state", c.key);
  }

  // Live edit from any control. Number fields are NOT rewritten mid-type (overwriteNumber=false)
  // so a partial entry like "1" while typing "175" is preserved; results use the clamped value.
  function onLiveInput(metric, el) {
    var n = parseFloat(el.value);
    if (!isFinite(n)) return;            // empty/partial field: keep last good result
    state[metric] = clamp(n, BOUNDS[metric]);
    render(metric, el.type === "range"); // sliders may overwrite the partner number field
    update();
  }

  // Commit (blur / Enter / slider release): normalize the field text to the clamped value.
  function onCommit(metric, el) {
    var n = parseFloat(el.value);
    if (!isFinite(n)) n = state[metric];
    state[metric] = clamp(n, BOUNDS[metric]);
    render(metric, true);
    update();
  }

  ["height", "weight"].forEach(function (metric) {
    ctrls[metric].forEach(function (el) {
      el.addEventListener("input",  function () { onLiveInput(metric, el); });
      el.addEventListener("change", function () { onCommit(metric, el); });
    });
  });

  // Initial paint.
  render("height", true);
  render("weight", true);
  update();
})();
